import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './styles.styl';

const Panel = props => (
  <div className={classnames(styles.wrapper, { [styles.tight]: props.tight })}>
    {props.children}
  </div>
);

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.clickAttached = false;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  componentDidMount() {
    this.checkAttachClickOutside();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.checkAttachClickOutside();
    }
  }

  componentWillUnmount() {
    window.document.removeEventListener('click', this.handleDocumentClick);
  }

  checkAttachClickOutside() {
    const { isOpen, onOpenChange } = this.props;
    if (!onOpenChange) {
      return;
    }
    if (isOpen) {
      if (this.clickAttached) {
        return;
      }
      window.document.addEventListener('click', this.handleDocumentClick);
      this.clickAttached = true;
    } else {
      if (!this.clickAttached) {
        return;
      }
      window.document.removeEventListener('click', this.handleDocumentClick);
      this.clickAttached = false;
    }
  }

  handleDocumentClick(event) {
    const { onOpenChange } = this.props;
    if (!this.elementRef) {
      return;
    }
    if (!this.elementRef.contains(event.target)) {
      onOpenChange(false);
    }
  }

  render() {
    const { isOpen, children, positionRight, positionBottom, width, block } = this.props;
    return (
      <div className={classnames(styles.container, this.props.className)} ref={(ref) => { this.elementRef = ref; }}>
        {isOpen &&
          <div
            className={classnames(styles.content, {
              [styles.content_right]: positionRight,
              [styles.content_bottom]: positionBottom,
              [styles.width_block]: block,
              [styles.width_md]: width === 'widthMd'
            })} >
            {children}
          </div>
        }
      </div>
    );
  }
}

export { Dropdown, Panel };



// WEBPACK FOOTER //
// ./src/components/shared/Dropdown/index.js